import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { EtiquetteService } from 'src/services/etiquette.service';
import { EtiquetteModel } from 'src/models/pilotage/contextePilotageUtilisateurModel';

import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { UtilisateurService } from 'src/services/utilisateur.service';
import { GestionEtiquettesUtilisateursModel } from 'src/models/pilotage/gestionEtiquettesUtilisateursModel';
import { RoleEntiteListPilotage } from 'src/models/pilotage/roleEntiteListPilotageModel';

@Component({
    selector: 'app-commun-etiquette',
    imports: [
    FormsModule,
    MatDialogModule,
    TranslateModule
],
    templateUrl: './commun-etiquette.component.html',
    styleUrl: './commun-etiquette.component.scss'
})
export class CommunEtiquetteComponent {
  availableEtiquettes: EtiquetteModel[] = [];
  selectedEtiquettes: EtiquetteModel[] = [];

  constructor(
    public dialogRef: MatDialogRef<CommunEtiquetteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      users: {
        utilisateurId: number,
        tousLesRolesEntites: RoleEntiteListPilotage[]
      }[],
      mode: 'add' | 'remove'
    },
    public utilisateurService: UtilisateurService,
    public etiquetteService: EtiquetteService
  ) { }

  ngOnInit() {
    this.loadEtiquettes();
  }

  loadEtiquettes() {
    const allEtiquettes = this.utilisateurService.contexteUtilisateur.toutesLesEtiquettes;

    const userEntityIds = new Set(
      this.data.users.flatMap(user =>
        user.tousLesRolesEntites.map(role => role.entiteId)
      )
    );

    this.availableEtiquettes = allEtiquettes.filter(etiquette => {
      const isGroupEtiquette = etiquette.entiteIds.some(entiteId => {
        const entite = this.utilisateurService.contexteUtilisateur.toutesLesEntites
          .find(e => e.entiteId === entiteId);
        return entite?.estGroupe;
      });

      const isUserEntityEtiquette = etiquette.entiteIds.some(id => userEntityIds.has(id));

      return isGroupEtiquette || isUserEntityEtiquette;
    });
  }

  onEtiquetteSelected(event: Event, selectElement: HTMLSelectElement): void {
    const etiquetteId = Number(selectElement.value);
    const etiquetteSelectionnee = this.availableEtiquettes.find(e => e.etiquetteId === etiquetteId);
    if (etiquetteSelectionnee) {
      this.selectedEtiquettes.push(etiquetteSelectionnee);
      this.availableEtiquettes = this.availableEtiquettes.filter(e => e.etiquetteId !== etiquetteId);
      selectElement.value = '';
    }
  }

  removeSelectedEtiquette(id: number): void {
    const removedEtiquette = this.selectedEtiquettes.find(e => e.etiquetteId === id);
    this.selectedEtiquettes = this.selectedEtiquettes.filter(e => e.etiquetteId !== id);
    if (removedEtiquette) {
      this.availableEtiquettes.push(removedEtiquette);
      this.availableEtiquettes.sort((a, b) =>
        this.etiquetteService.getNomLocalise(a.locales).localeCompare(
          this.etiquetteService.getNomLocalise(b.locales)
        )
      );
    }
  }

  onConfirm() {
    const model: GestionEtiquettesUtilisateursModel = {
      utilisateurIds: this.data.users.map(u => u.utilisateurId),
      etiquetteIds: this.selectedEtiquettes.map(e => e.etiquetteId)
    };

    const operation = this.data.mode === 'add'
      ? this.utilisateurService.ajouterUtilisateursEtiquettes(model)
      : this.utilisateurService.supprimerUtilisateursEtiquettes(model);

    operation.subscribe(
      () => {
        this.dialogRef.close(true);
      },
      error => {
        console.error(`Error ${this.data.mode}ing tags:`, error);
      }
    );
  }

  onCancel() {
    this.dialogRef.close();
  }
}
